import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Rocket, Loader2, Mail } from "lucide-react";
import { subscribeInterest } from "@/lib/api";

export default function UpgradeDialog({ open, onClose, email }) {
  const [busy, setBusy] = useState(false);

  const onRequest = async () => {
    setBusy(true);
    try {
      await subscribeInterest();
      toast.success("Request sent to GloGrid", {
        description: "Our team will reach out to set up your subscription.",
      });
      onClose();
    } catch (e) {
      toast.error("Could not send request", {
        description: e?.response?.data?.detail || "Please email connect@glogrid.com directly.",
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm border-slate-200 sm:max-w-md" data-testid="upgrade-dialog">
        <DialogHeader>
          <div className="mb-1 grid h-11 w-11 place-items-center rounded-sm bg-blue-600 text-white">
            <Rocket className="h-5 w-5" />
          </div>
          <DialogTitle className="font-heading text-2xl font-extrabold tracking-tight text-slate-900">
            You've used your free estimates
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            You've reached the limit of free estimates for this month. Subscribe with GloGrid to keep generating
            unlimited VMI &amp; warehousing quotes.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-sm bg-slate-50 p-4 text-sm text-slate-600">
          Tap below and our team will contact {email ? <span className="font-semibold text-slate-900">{email}</span> : "you"} to
          get you set up with a subscription.
        </div>

        <div className="mt-2 flex flex-col gap-2">
          <Button
            onClick={onRequest}
            disabled={busy}
            className="h-12 rounded-sm bg-slate-900 font-semibold text-white transition-colors hover:bg-blue-600 disabled:opacity-50"
            data-testid="upgrade-request-btn"
          >
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Rocket className="mr-2 h-4 w-4" />}
            Request a subscription
          </Button>
          <a
            href="mailto:connect@glogrid.com?subject=GloGrid%20VMI%20Quoter%20Subscription"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-sm border border-slate-300 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100"
            data-testid="upgrade-mailto"
          >
            <Mail className="h-4 w-4" /> Email connect@glogrid.com
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
